import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import { sync } from 'vuex-router-sync'

Vue.config.productionTip = false

import VueSplit from 'vue-split-panel'
//https://github.com/bajaniyarohit/vue-split-panel
//https://redstapler.co/split-js-tutorial-website-split-screen-effect/

import VueI18n from "vue-i18n";
import en from "./locales/en.json";
import la from "./locales/la.json";
//https://dev.to/lucasferreiralimax/how-implementation-a-i18n-in-vue-3-4cen

Vue.use(VueSplit)

Vue.use(VueI18n);

sync(store, router)

// Create VueI18n instance with options
const i18n = new VueI18n({
  lazy:true,
  locale: "la",
  messages: { la, en },
});


new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')